// extracted by mini-css-extract-plugin
export var card = "card-svg-module--card--0b4d3";
export var cardContent = "card-svg-module--cardContent--ad7bc";
export var date = "card-svg-module--date--d8bef";
export var title = "card-svg-module--title--76c03";